import React from 'react';
import { Box, TableContainer, Table, TableBody, CircularProgress, Typography } from '@mui/material';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { endPoints } from 'api/endpoints';
import { useRecoilState } from 'recoil';
import { OrderPayload, isMembersApiLoading } from 'pages/myidm/store';
import { Styles, ADGroupStyledTableCell, StyledTableRow } from 'pages/myidm/style';
import FormCard from 'pages/myidm/components/form-card';

const ADGroupMembers = () => {
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [, setMebersApiLoader] = useRecoilState(isMembersApiLoading);
    const adGroupMembersApi = useMutation(() => axios.get(`${endPoints?.myIdm?.adGroupMembersApi}/${order?.adGroup}`));
    const adGrpUniversalApi = useMutation(() => axios.get(`${endPoints?.myIdm?.adGroupIsUniversalApi}/${order?.adGroup}`));

    React.useEffect(() => {
        if (adGroupMembersApi?.isSuccess) setMebersApiLoader(false);
        if (adGroupMembersApi?.isSuccess && adGroupMembersApi?.data?.data) {
            setOrder({ ...order, adGroupMembers: adGroupMembersApi?.data?.data });
        }
    }, [adGroupMembersApi?.isSuccess]);
    React.useEffect(() => {
        if (order?.adGroup && !adGrpUniversalApi?.isLoading) {
            setMebersApiLoader(true);
            adGroupMembersApi?.mutate();
        }
    }, [order?.adGroup, adGrpUniversalApi?.isLoading]);

    React.useEffect(() => {
        if (adGrpUniversalApi?.isSuccess && adGrpUniversalApi?.data?.data) {
            setOrder({ ...order, isUniversalADGroup: adGrpUniversalApi?.data?.data?.isUniversalGroup });
        }
    }, [adGrpUniversalApi?.isSuccess]);
    React.useEffect(() => {
        if (order?.adGroup) {
            adGrpUniversalApi?.mutate();
        }
    }, [order?.adGroup]);
    return (
        <Box>
            <FormCard title="AD Group Members List" gap={0} showDivider={false}>
                <Box data-testid="members-list" sx={{ width: '100%' }}>
                    {adGroupMembersApi.isLoading && (
                        <Box sx={Styles?.addMembersCard?.loader}>
                            <CircularProgress color="inherit" size={16} />
                            <Typography variant="body2" sx={{ color: '#000000', marginTop: 1 }}>
                                Loading...
                            </Typography>
                        </Box>
                    )}
                    {adGroupMembersApi?.isError && !adGroupMembersApi?.isLoading && <Box sx={Styles?.addMembersCard?.wrongMsg}>Something is Wrong</Box>}
                    {!adGroupMembersApi?.isError &&
                        !adGroupMembersApi?.isLoading &&
                        (adGroupMembersApi?.data?.data?.length === 0 || adGroupMembersApi?.data?.data === null || order?.adGroupMembers === null) && (
                            <Box sx={Styles?.addMembersCard?.nomembers}>No Members</Box>
                        )}
                    {!adGroupMembersApi.isLoading && !adGroupMembersApi.isError && adGroupMembersApi?.data?.data?.length > 0 && order?.adGroupMembers && (
                        <TableContainer sx={Styles?.AddMemberForm?.table.AdGrptableWrapper}>
                            <Table sx={{ ...Styles?.AddMemberForm?.table?.memListmain, minHeight: '50px', borderSpacing: 0 }} size="small" stickyHeader>
                                <TableBody>
                                    {!adGroupMembersApi?.isLoading && adGroupMembersApi?.data?.data?.length > 0 && order?.adGroupMembers?.length > 0 && (
                                        <>
                                            {order?.adGroupMembers?.map((member) => (
                                                <StyledTableRow className="animate-opacity" key={member?.gpid}>
                                                    <ADGroupStyledTableCell>{member?.gpid || ''}</ADGroupStyledTableCell>
                                                    <ADGroupStyledTableCell>{`${member.firstName} ${member?.lastName}` || '-'}</ADGroupStyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Box>
            </FormCard>
        </Box>
    );
};

export default ADGroupMembers;
